import { createStore, applyMiddleware, Action } from 'redux'
import thunkMiddleware, { ThunkAction } from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux'

/*Bug 456 @Author Anupama P @Date 18/06/2021 */
import   authenticationSlice   from 'reducers/authenticationSlice';
import { loadState, saveState } from 'shared/utils/common-utils';
/* end Bug 456 */
import  local from "store2";
const composedEnhancer = composeWithDevTools(applyMiddleware(thunkMiddleware));
 let preloadedState = local.get('state') ? local.get('state'): {};
 
//console.log(preloadedState)
const rootReducer = combineReducers({
    // Define a top-level state field named `todos`, handled by `todosReducer`
    authentication: authenticationSlice,
  })
 
  export const store = configureStore({
    reducer: rootReducer,
    middleware: [thunkMiddleware],
    preloadedState: preloadedState
  })
//export const store = createStore(rootReducer, composedEnhancer);
 
store.subscribe(() => {
    //console.log('on store change')
    local.set('state',{
        authentication: store.getState().authentication
      })
   
  });
  export type RootState = ReturnType<typeof store.getState>;
  export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
  >;